// extracted by mini-css-extract-plugin
module.exports = {"Container":"CommentComposer_Container__34Ed0","Actions":"CommentComposer_Actions__pqS4Q"};